<template>
    <ul
        v-if="result?.listings?.length > 0"
        class="house-grid layout13"
        :class="['count-' + result?.listings?.length]"
    >
        <house
            v-for="item in result?.listings"
            :key="item.detailLink"
            :house="item"
        />
    </ul>
</template>

<script>
import HouseGrid from '../house-grid';
import house from './house.vue';
export default {
    mixins: [HouseGrid],
    components: {
        house
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.house-grid.layout13 {
    display: flex;
    flex-wrap: wrap;
    column-gap: 16px;
    row-gap: 40px;
    position: relative;
    margin-top: 40px;
    @include media-800 {
        flex-direction: column;
        row-gap: 20px;
        margin-top: 20px;
    }
    &.count-1 {
        justify-content: center;
    }
    &.count-1,
    &.count-2 {
        .house-grid-item.layout13 {
            width: calc((100% - 16px) / 2);
            @include media-800 {
                width: 100%;
            }
        }
    }
}
</style>
